import React, { useEffect, useRef , useState} from "react"
import { useForm } from "react-hook-form"
import { useRecaptcha } from "react-hook-recaptcha"

const recaptchaContainerId = "recaptcha-container"
const sitekey = "6LfKIQEiAAAAAFoPMOD9Oeoj2uC8Zke81zo4ewd3"; // change to your site key

const useFormWithRecaptcha = ({ onSubmit, ...formConfig }) => {
  const formMethods = useForm(formConfig)
  const onSubmitRef = useRef(onSubmit)
  const formMethodsRef = useRef(formMethods)
  const windowGlobal = typeof window !== "undefined" && window
  const [recaptchaLoadedX, setRecaptchaLoadedX] = useState(false);
  const [recaptchaWidgetX, setRecaptchaWidgetX] = useState(null);

  useEffect(() => {
    onSubmitRef.current = onSubmit
    formMethodsRef.current = formMethods
  })

  const successCallback = (response) => {
    return formMethodsRef.current.handleSubmit((data) => {
      //add recaptcha field to data
      return onSubmitRef.current({ ...data, "g-recaptcha-response": response })
    })()
  }
  
 if (windowGlobal) {
    const{recaptchaLoaded, recaptchaWidget}  = useRecaptcha({
        containerId: recaptchaContainerId,
        sitekey: sitekey,
        size: "invisible",
        successCallback,
    })
    if (recaptchaLoaded && !recaptchaLoadedX) (
        setRecaptchaLoadedX(true)
    )
    if (recaptchaWidget !== null && recaptchaWidgetX === null) {
        setRecaptchaWidgetX(recaptchaWidget);
    }
 }

  const executeRecaptcha = (e) => {
    e.preventDefault()
    if(recaptchaWidgetX !== "null" && windowGlobal) {
      windowGlobal.grecaptcha.reset(recaptchaWidgetX)
      windowGlobal.grecaptcha.execute(recaptchaWidgetX)
    }
  }

  const resetRecaptcha = () => {
    if (recaptchaWidgetX !== "null"  && windowGlobal) {
      windowGlobal.grecaptcha.reset(recaptchaWidgetX)
    }
  }

  const recaptchaComponent = <div id={recaptchaContainerId} />

  return {
    ...formMethods,
    recaptchaLoadedX,
    recaptchaComponent,
    executeRecaptcha,
    resetRecaptcha,
  }
}

export default useFormWithRecaptcha